/**
 * @fileoverview POST handler for the "/engagement/webhook_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { WebhookMessageTemplateIdResult } from "../webhookMessageTemplateId";
import { engagementWebhookTemplatesIdCacheKeys } from "./constants";
import type { PostEngagementWebhookTemplatesIdProps } from "./types";

export const postEngagementWebhookTemplatesId = reactQueryMutationAdapter(
  engagementWebhookTemplatesIdCacheKeys,
  (props: PostEngagementWebhookTemplatesIdProps): Promise<WebhookMessageTemplateIdResult> => {
    return fetch(`/engagement/webhook_templates/${props.id}`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
